<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">Número</th>
        <th scope="col" class="border-0" v-if="isModel">Modelo</th>
        <th scope="col" class="border-0" v-else>Cliente</th>
        <th scope="col" class="border-0 text-center">Classificação</th>
        <th scope="col" class="border-0 text-center">Criado em</th>
        <th scope="col" class="border-0 text-center">Enviado</th>
        <th scope="col" class="border-0">Tipo</th>
        <th scope="col" class="border-0" v-if="!isCustomer && !isModel">Atribuido</th>
        <th scope="col" class="border-0 text-center">Status</th>
        <th scope="col" class="border-0 text-center" v-if="!isCustomer"><i class="fas fa-comment"></i></th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in quotations" :key="index" class="align-items-center">
        <td class="td-1 border-color" :style="{'borderLeftColor': row.priority.color}">{{ row.reference_no }}</td>
        <td class="td-5 link">
          <template v-if="isCustomer">
            <span>{{ row.customer_name }}</span>
          </template>
          <template v-else>
            <d-link :to="{ name: 'admin-quotation-model-edit', params: { quotationId: row.id }}" v-if="isModel">{{ row.model_name }}</d-link>
            <d-link :to="{ name: 'admin-quotation-edit', params: { quotationId: row.id }}" v-else>
              <span v-if="row.customer_name">{{ row.customer_name }}</span>
              <span v-else class="no-content">Sem cliente</span>
            </d-link>
          </template>
        </td>
        <td class="td-2 text-center"><input-star :model='row.rating' :max-rating='5' :read-only='true' :starSize='25'/></td>
        <td class="td-2 text-center">{{ row.f_created_at }}</td>
        <td class="td-1 text-center">
          <i class="fas fa-info-circle" :id="'tooltip-'+index"></i>
          <d-tooltip :target="'#tooltip-'+index" container=".tooltip-container">
            <p class="m-0 tooltip-date"><i class="fas fa-envelope"></i> {{ row.sent_mail_at }}</p>
            <p class="m-0 tooltip-date"><i class="fab fa-whatsapp"></i> {{ row.sent_whatsapp_at }}</p>
          </d-tooltip>
        </td>
        <td class="td-2">{{ row.type.name }}</td>
        <td class="td-2" v-if="!isCustomer && !isModel">{{ (row.assign && row.assign.user) ? row.assign.user.name : '-' }}</td>
        <td class="td-3 text-center">
          <span v-if="row.status.slug == 'closed'" class="btn-sm btn-primary">DESISTIU</span>
          <span v-else-if="row.status.slug == 'approved'" class="btn-sm btn-success">GOL <i class="fas fa-futbol"></i></span>
          <span v-else-if="row.status.slug == 'approved-payment'" class="btn-sm btn-info">PAGO <i class="fas fa-dollar-sign"></i></span>
          <span v-else-if="row.status.slug == 'approved-admin'">Aprovado por: {{row.approved_user.name}}</span>
          <span v-else>{{ row.status.name }}</span>
        </td>
        <td class="td-2 text-center" v-if="!isCustomer">
          <div class="comments" @click="openComments(row)">
            <i class="fas fa-comment"></i>
            <d-badge pill theme="danger">{{row.comments.length}}</d-badge>
          </div>
        </td>
        <td class="td-2">
          <quotation-buttons :is-model="isModel" :quotation="row"></quotation-buttons>
        </td>
      </tr>
      <tr v-if="quotations.length === 0">
        <td colspan="10" class="no-content">Ainda não tem nenhum orçamento.</td>
      </tr>
    </tbody>
    <mark-as-sentModal :quotation-id="selectedQuotation" :status="newStatus"/>
    <import-modals/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import MarkAsSentModal from '_modules/quotation/components/modal/MarkAsSentModal.vue';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import QuotationService from '_services/rest/modules/quotation';
import InputStar from '_shared/InputStar.vue';
import { _LOAD_COMMENTS_, _OPEN_CONFIRMATION_ } from './QuotationModel';

export default {
  name: 'customer-table',
  components: {
    InputStar,
    ImportModals,
    MarkAsSentModal,
    QuotationButtons,
  },
  props: {
    quotations: {
      type: Array,
    },
    isModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  data() {
    return {
      isCustomer: false,
      selectedQuotation: null,
      newStatus: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'checkIsCustomer',
    ]),
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    openChoseModal(newStatus, quotation) {
      this.selectedQuotation = quotation.id;
      this.newStatus = newStatus;
      this.setToggle({ type: 'mark_as_sent_modal', bool: true });
    },
    changeStatus(newStatus, quotation) {
      if (newStatus === 'pending' && quotation.status === 'open') {
        return this.openChoseModal(newStatus, quotation);
      }
      if (newStatus === 'approved') {
        this.setToggle({ type: 'confirm_modal', bool: true });
        Events.$emit(_OPEN_CONFIRMATION_, { quotation, type: 'approved' });
        return true;
      }
      return this.updateStatus(newStatus, quotation);
    },
    openComments(quotation) {
      this.setToggle({ type: 'comments_modal', bool: true });
      Events.$emit(_LOAD_COMMENTS_, quotation);
    },
    updateStatus(newStatus, quotation) {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updateStatus(quotation.id, newStatus)
        .then(() => this.activeAlert({ message: 'Status do orçamento alterado com sucesso', theme: 'success' }))
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    this.checkUser();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.btn-success {
  vertical-align: middle;
  font-size: 14px;
}

.border-color {
  border-left: 10px solid ;
}
.link {
  color: $primary;
  a {
    cursor: pointer;
  }
  .overlay {
    opacity: 0;
    cursor: pointer;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
.align-items-center {
  td {
    vertical-align: middle;
  }
  .btn-sm { padding: 0.4rem 0.7rem; }
}
.td {
  &-1 {
    width: 1%;
    min-width: 20px;
  }
  &-2 {
    width: 3%;
  }
  &-3 {
    width: 7%;
    min-width: 120px;
  }
  &-4 {
    width: 8%;
    min-width: 330px;
  }
  &-5 {
    width: 14%;
    min-width: 145px;
  }
}
.min-select {
  min-width: 125px;
}

.tooltip {
  &-date {
    font-size: 14px;
  }
}

.fa-comment {
  font-size: 20px;
}

.comments {
  position: relative;
  width: 30px;
  cursor: pointer;
  display: inline-block;
  .badge {
    position: absolute;
    top: -5px;
    right: -5px;
    padding: 4px;
  }
}
</style>
